import React from 'react';
import {
  FieldValues, useController, Path, PathValue,
} from 'react-hook-form';
import MultiAutoComplete, { MultiAutoCompleteProps } from '.';
import { CommonReactHookFormProps } from '../types';

interface RHFMultiAutoCompleteProps<
  T, Value, FormFields extends FieldValues,
> extends MultiAutoCompleteProps<T, Value>, CommonReactHookFormProps<FormFields> {
  onSelectChange?: (data: Value[]) => void;
}

function RHFMultiAutoComplete<T, Value, FormFields extends FieldValues>(
  props: RHFMultiAutoCompleteProps<T, Value, FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    options,
    onChange,
    onSelectChange,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange: onFieldChange } = field;

  const handleChange = (event: Value[]) => {
    onFieldChange(event);
    if (onSelectChange) {
      onSelectChange(event);
    }
  };

  return (
    <MultiAutoComplete
      label={label}
      error={error}
      value={field.value}
      options={options}
      onChange={handleChange}
      {...rest}
    />
  );
}

RHFMultiAutoComplete.defaultProps = {
  onSelectChange: () => { },
};

export default RHFMultiAutoComplete;
